import React from 'react';
import s from './TableElements.module.css';
import TableElement from './TableElement';
import {Transaction} from '../../../types/TypesUserAccounts';
type Props = {
	transactions: Transaction[];
};
const TableContent: React.FC<Props> = ({transactions}) => {
	return (
		<div className={s.tableContentContainer}>
			{transactions && (
				<div className={s.rowElements}>
					{transactions?.map((transaction) => {
						return (
							<TableElement
								transaction={transaction}
								key={transaction.transaction_id}
							/>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default TableContent;
